document.addEventListener("DOMContentLoaded", () => {
    const menuItems = document.querySelectorAll('nav a[href^="#"]');
    const sections = document.querySelectorAll('section');
    const scrollButtons = document.querySelectorAll('.scroll-to-pricing');
    const fixedMenuHeight = 70;

    const smoothScroll = (href: string) => {
        const targetElement = document.querySelector(href);
        if (targetElement) {
            const offsetTop = targetElement.getBoundingClientRect().top + window.pageYOffset - fixedMenuHeight;
            window.scrollTo({
                top: offsetTop,
                behavior: "smooth"
            });
            setTimeout(checkSectionInView, 600);
        }
    };

    const handleLinkClick = (e: Event) => {
        e.preventDefault();
        const href = (e.currentTarget as HTMLAnchorElement).getAttribute('href');
        if (href) smoothScroll(href);
    };

    menuItems.forEach(item => {
        item.addEventListener('click', handleLinkClick);
    });

    scrollButtons.forEach(button => {
        button.addEventListener('click', (e) => {
            e.preventDefault();
            smoothScroll('#pricing');
        });
    });

    const checkSectionInView = () => {
        const scrollPosition = window.scrollY + fixedMenuHeight;
        const buffer = 5;
        const nearBottom = window.innerHeight + window.scrollY >= document.body.offsetHeight - buffer;
        let currentSectionId = "";

        sections.forEach(section => {
            const sectionTop = section.offsetTop - buffer;
            const sectionHeight = section.offsetHeight;

            if (scrollPosition >= sectionTop && scrollPosition <= sectionTop + sectionHeight + buffer) {
                currentSectionId = section.getAttribute('id') || "";
            }
        });

        if (nearBottom) {
            currentSectionId = sections[sections.length - 1]?.getAttribute('id') || "";
        }

        menuItems.forEach(item => {
            item.classList.remove('active');
            if (item.getAttribute('href') === '#' + currentSectionId) {
                item.classList.add('active');
            }
        });
    };

    window.addEventListener('scroll', checkSectionInView);

    const hamburger = document.querySelector('.hamburger');
    const menu = document.querySelector('.menu');

    if (hamburger && menu) {
        hamburger.addEventListener('click', () => {
            menu.classList.toggle('active');
            setTimeout(checkSectionInView, 300);
        });
    }

    menuItems.forEach(item => {
        item.addEventListener('click', () => {
            if (menu?.classList.contains('active')) {
                menu.classList.remove('active');
            }
        });
    });
});
